/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DocumentInitialsV1Dto = {
  /**
   * Alignment of the Initials on the document. The left, right and center options are aligned on top of the page by default
   */
  alignment?: DocumentInitialsV1Dto.alignment;
  /**
   * Offset of the initials from the edge of the page (in pixels). The offset is from the top or bottom of the page, depending on what has been defined in the alignment attribute.
   */
  y?: number;
};
export namespace DocumentInitialsV1Dto {
  /**
   * Alignment of the Initials on the document. The left, right and center options are aligned on top of the page by default
   */
  export enum alignment {
    BOTTOM_CENTER = 'bottom-center',
    BOTTOM_LEFT = 'bottom-left',
    BOTTOM_RIGHT = 'bottom-right',
    CENTER = 'center',
    LEFT = 'left',
    RIGHT = 'right',
    TOP_CENTER = 'top-center',
    TOP_LEFT = 'top-left',
    TOP_RIGHT = 'top-right',
  }
}
